import { EventInstrument } from "../types/Instrument";
import { deleteData, getData, postData } from "./apiService";

export const getEventInstruments = async (event_id: string): Promise<EventInstrument[]> => {
    try {
      // Call getData with the endpoint and optional parameters
      const response = await getData(`/event-instruments/${event_id}`, {});  // The API call is unchanged
      // Assuming the API returns an array of events in response.data
      return response.data as EventInstrument[];  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to fetch event:', error);
      return [];  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };

  export const removeEventInstrument = async (event_id: string, instrument_id: string) => {
    try {
      // Call getData with the endpoint and optional parameters
      const response = await deleteData(`/event-instruments`, {event_id: event_id, instrument_id: instrument_id});  // The API call is unchanged
      // Assuming the API returns an array of events in response.data
      return response;  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to fetch event:', error);
      return;  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };

  export const addEventInstrument = async (event_id: string, instrument_id: string) => {
    try {
      // Call getData with the endpoint and optional parameters
      const response = await postData(`/event-instruments/`, {event_id: event_id, instrument_id: instrument_id});  // The API call is unchanged
      // Assuming the API returns an array of events in response.data
      return response;//response as EventInstrument[];  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to fetch event:', error);
      return;// [];  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };

  export const addEventInstruments = async (event_id: string, instrument_ids: string[]) => {
    try {
      // Call getData with the endpoint and optional parameters
      const response = await postData(`/event-instruments/set`, {event_id: event_id, instrument_ids: instrument_ids});  // The API call is unchanged
      // Assuming the API returns an array of events in response.data
      return response;//response as EventInstrument[];  // Type assertion to ensure it matches the Event[] type
    } catch (error) {
      console.error('Failed to fetch event:', error);
      return;// [];  // Return an empty array in case of an error (or you could throw error, based on your error handling strategy)
    }
  };